module.exports = __webpack_public_path__ + "img/tdp_tbt1256_1993.prt.6ffb8565.jpg";